import { render, staticRenderFns } from "./ResponsavelProcessamentoTexto.vue?vue&type=template&id=066dff70&"
import script from "./ResponsavelProcessamentoTexto.vue?vue&type=script&lang=js&"
export * from "./ResponsavelProcessamentoTexto.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports